import { AreaItem } from './area-item';
import { BookingSlot } from './booking-slot';

export class EventAreaItemSlot {
  private _name: string;
  private _areaItem: AreaItem;
  private _bookingSlot: BookingSlot;


  constructor(
    name: string,
    areaItem: AreaItem = null,
    bookingSlot: BookingSlot = null,
  ) {
    this._name = name;
    this._areaItem = areaItem;
    this._bookingSlot = bookingSlot;
  }

  static createFromAny(object: any): EventAreaItemSlot {
    if (object === null || object === undefined) {
      return null;
    }

    return new EventAreaItemSlot(
      object.name ? object.name : '',
      object.areaItem ? AreaItem.createFromAny(object.areaItem) : null,
      object.bookingSlot ? BookingSlot.createFromAny(object.bookingSlot) : null,
    );
  }

  get name(): string {
    return this._name;
  }

  get areaItem(): AreaItem {
    return this._areaItem;
  }

  get bookingSlot(): BookingSlot {
    return this._bookingSlot;
  }
}
